import { createSlice } from '@reduxjs/toolkit';
import { IRegionSpecialPromo } from 'shared/types/specialPromos';

const initialState: IRegionSpecialPromo[] = [];

export const specialPromosSlice = createSlice({
  name: 'specialPromos',
  initialState,
  reducers: {},
});

export const { reducer: specialPromosReducer, name: specialPromosReducerName } = specialPromosSlice;
